import { render } from "./customSelect.vue?vue&type=template&id=54824662&scoped=true"
import script from "./customSelect.vue?vue&type=script&lang=js"
export * from "./customSelect.vue?vue&type=script&lang=js"

import "./customSelect.vue?vue&type=style&index=0&id=54824662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54824662"]])

export default __exports__